<template>
<div class="SignEventDetails">
    <el-form ref="form" :model="form" label-width="110px" label-position="left">
        <div class="item">
            <header><p>基本信息</p></header>
                <el-form-item label="活动名称">
                    <el-input v-model="form.title" :disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="活动简介">
                    <el-input type="textarea" v-model="form.subtitle" :disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="活动封面">
                    <img class="fm" :src="form.coveratturlid.furl" :alt="form.title">
                </el-form-item>
                <el-form-item label="活动时间段">
                    <el-input v-model="form.begintime" :disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="活动详情">
                    <div class="ueditorBox">
                        <uEditor :content="form.eventdesp" ref="uEditor" @getUEditorContent="getUEditorContent" :disabled="disabled"></uEditor>
                    </div>
                </el-form-item>
        </div>
        <div class="item">
            <header>
                <p>签到配置</p>
            </header>
            <el-form-item label="活动地点">
                <el-input v-model="form.eventplace" :disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item label="签到类型">
                <el-input v-model="form.signtype" :disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item label="是否名单验证">
                <el-radio-group v-model="form.isverifylist" :disabled="true">
                    <el-radio :label=1>开启</el-radio>
                    <el-radio :label=0>关闭</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="签到周期类型">
                <el-radio-group v-model="form.signtimetype" :disabled="true">
                    <el-radio :label=1>一次性</el-radio>
                    <el-radio :label=2>按日</el-radio>
                    <el-radio :label=3>按周</el-radio>
                </el-radio-group>

            <div class="time" v-if="form.signtimetype == 3">
                    <el-form-item label="签到周期选择">
                        <el-input v-model="form.signtimescope" :disabled="disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="周期内签到时间">
                        <el-input v-for="(item, index) in form.signtimeinfo" :key="index" v-model="item.value" :disabled="disabled"></el-input>
                    </el-form-item>
            </div>
            </el-form-item>
        </div>
        <div class="sign-in item">
            <header>
                <p>签到信息</p>
            </header>
            <el-form-item :label="item.isnotnull == 1 ? '必填':'不必填'" v-for="(item, index) in form.eventformlist" :key="index">

                <el-input v-model="item.colname" :disabled="disabled"></el-input>

                <div class="list" v-if="item.coltype == 5 || item.coltype == 6 || item.coltype == 7 || item.coltype == 8">
                    <p style="margin-top:20px">选项列表</p>
                    <el-input v-model="spiltItem.value" v-for="(spiltItem, i) in item.optionsinfo" :key="i" :disabled="disabled"></el-input>
                </div>
                
            </el-form-item>
        </div>
        <div class="set-up item">
            <header>
                <p>活动设置</p>
            </header> 
            <el-form-item label="传播隐私设置">
                <el-input v-model="form.sharetype" :disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item label="留言设置">
                <el-input v-model="form.commentpritype" :disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item label="参与有奖励">
                <div class="min">
                    <span>奖励总金额</span>
                    <el-input v-model="form.joinawardtotalmoney" :disabled="disabled"></el-input>
                    <span>奖励数量</span>
                    <el-input v-model="form.joinawardtotalcount" :disabled="disabled"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="分享有奖励">
                <div class="min">
                    <span>单个奖励金额</span>
                    <el-input v-model="form.shareawardtotalcount" :disabled="disabled"></el-input>
                    <span>奖励数量</span>
                    <el-input v-model="form.shareawardsinglemoney" :disabled="disabled"></el-input>
                </div>
            </el-form-item>
        </div>
    </el-form>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import { getSignEventDetail } from 'api/operateToolApi'
import UEditor from 'base/uEditor/uEditor'
export default {
    name: 'SignEventDetails',
    data() {
        return {
            eventinnerid: this.$route.query.eventinnerid, // 活动ID
            disabled: false,
            form: {
                    title:'', // 活动标题
                    subtitle:'', //  活动简介
                    coveratturlid:'', //  活动Logo图对象
                    begintime:'', //  活动开始时间
                    endtime:'', //  活动结束时间
                    eventdesp:'', //  活动详情
                    eventplace:'', //  活动地点
                    signtype:'', //  签到类型:  1 自助签到 2 取票签到
                    isverifylist:'', //  是否验证名单：0否 1是
                    signtimetype:'', //  签到周期类型: 1一次性   2按日  3按周
                    signtimescope:'', //  签到周期时间
                    signtimeinfo:'', //  签到时间区间
                    status:'', //  活动状态 0, 待发布 10, 进行中  11, 暂停中  30, 已完成  100,已取消 
                    //签到信息
                    eventformlist: [    //  签到表单list
                        {
                            colindex:'', //   序号 
                            colinnerid:'', //   表单InnerID
                            colname:'', //   字段名称
                            coltype:'', //   字段类型：1 单行文本框 2 数字文本框 3 日期选择框 4 邮箱输入框 5 多行文本框 6 单选按钮框 7 多选按钮框 8 下拉选择框
                            placeholder:'', //   字段提示语
                            optionsinfo:'', //   下拉选项表：多个以逗号隔开
                            ispublic:'', //   是否公开 
                            isnotnull:'', //   是否必填
                        }
                    ], 

                    //活动设置
                    sharetype:'', //   传播隐私设置 1所有人均可转发  2只有发布者可以转发
                    isopencomment:'', //   留言设置  0否 1是
                    isjoinaward:'', //   是否参与奖励 0否 1是 
                    joinawardtotalmoney:'', //   参与奖励总金额 
                    joinawardtotalcount:'', //   参与奖励总个数 
                    isshareaward:'', //   是否分享奖励 0否 1是 
                    shareawardtotalcount:'', //   分享奖励总个数 
                    shareawardsinglemoney:'', //   分享奖励单个金额" 
                },
        }
    },
    mounted() {
        this.setLoading(true)
        getSignEventDetail({
            data: {eventinnerid: this.eventinnerid},
            success: data => {
                this.setLoading(false)
                this.form = data.data
                this.form.begintime = `${this.form.begintime} 至 ${this.form.endtime}`
                 // 活动详情渲染
                this.$refs.uEditor.init(this.form.eventdesp)

                for (let i = 0; i < this.form.eventformlist.length; i++) {

                    if (this.form.eventformlist[i].coltype == 6 || this.form.eventformlist[i].coltype == 7 || this.form.eventformlist[i].coltype == 8) {
                        
                        let data = [],
                            optionsinfo = this.form.eventformlist[i].optionsinfo,
                            optionsinfoItem = optionsinfo.split(',')

                        for (let j = 0; j < optionsinfoItem.length; j++) {
                            data.push({value: optionsinfoItem[j]})
                        }

                         this.form.eventformlist[i].optionsinfo = data
                    }
                }

                if (this.form.signtimetype == 3) {
                    // let signtimeinfo = this.form.signtimeinfo.split(','),
                    let signtimeinfo = this.form.signtimeinfo,
                        sinarr = []
    
                    for (let i = 0; i < signtimeinfo.length; i++) {
                        sinarr.push({value: signtimeinfo[i]})
                    }    
                    this.form.signtimeinfo = sinarr
    
                    console.log( this.form.signtimeinfo)
                }

                // this.form.eventformlist.unshift({ //  表单list
                //         colinnerid: '', // 表单InnerID
                //         colname: '姓名', // 字段名称 
                //         colindex: '', // 序号 
                //         coltype: 1, // 字段类型： 1 单行文本框 2 数字文本框  3 日期选择框  4 邮箱输入框 5 多行文本框6 单选按钮框 7 多选按钮框 8 下拉选择框  \n
                //         placeholder: '', // 字段提示语
                //         optionsinfo: "", // 下拉选项表：表单提交时 多个以逗号隔开
                //         isnotnull: 1, // 是否必填" 
                //         ispublic: 0,   // 是否公开
                //     },
                //     { //  表单list
                //         colinnerid: '', // 表单InnerID
                //         colname: '手机', // 字段名称 
                //         colindex: '', // 序号 
                //         coltype: 1, // 字段类型： 1 单行文本框 2 数字文本框  3 日期选择框  4 邮箱输入框 5 多行文本框6 单选按钮框 7 多选按钮框 8 下拉选择框  \n
                //         placeholder: '', // 字段提示语
                //         optionsinfo: "", // 下拉选项表：表单提交时 多个以逗号隔开
                //         isnotnull: 1, // 是否必填" 
                //         ispublic: 0,   // 是否公开
                // })

                this.$nextTick(() => {
                    this.form = JSON.parse(JSON.stringify(this.form))
                })
        
            },
            error: data => {
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })
    
    },
    methods: {
        // 详情信息 
        getUEditorContent(content) {
            this.form.eventdesp = content
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        UEditor
    }
}
</script>

<style lang="scss" type="text/scss">
.SignEventDetails {
    .item {
        margin-bottom: 20px;
        border-bottom: solid 1px #eee;
    }
    .ue_btn {
        display: none;
    }
    .el-textarea {
        width: 400px;
        height: 80px;

        .el-input {
            height: 100%;
        }
    }
    .el-input {
        max-width: 400px;

        input {
            width: 100%;
        }
    }
    .time {
        .el-input {
            display: block;
            margin-bottom: 20px;
            max-width: 268px;
        }
    }

    .sign-in {
        .el-input {
            display: block;
            max-width: 128px;
        }

        .list {
            .el-input {
                margin-top: 20px;
                display: block;
                max-width: 277px;
            }   
        }

    }
    .set-up {
        .min {
            .el-input {
                margin: 0 20px;
                max-width: 116px;
            }   
        }
 
    }

    .fm {
        display: block;
        width: 318px;
        height: 178px;
        border-radius: 4px;
    }
    header {
        height: 60px;
        p {
            padding-left: 20px;
            font-size: 16px;
            color: #333;
            border-left: solid 2px #409eff 
        }
    }
}
</style>